import React, { Component } from 'react';


class Dest extends Component {
  constructor(props){
    super(props)
    this.state = {
      postObj:[],
      url:'',
    }
  }

  componentDidMount(){
    this.setState({ 
      postObj: this.props.itemPost,
      url: this.props.urlact
    })
  }

  componentWillReceiveProps(next_props) {
    if(next_props.itemPost !== this.state.postObj){
      this.setState({ 
        postObj: next_props.itemPost,
        url: this.props.urlact
      })
    }
  }

  render() {
    const data = this.state.postObj

    return (
      <div>
      {
        data.map((item, i) => {

          return (
            <div className="item-post-content" key={i}>
              <div>
                  { item.imgft_field.length > 0 &&
                    <img src={item.imgft_field} alt=""/>
                  }
                </div>
            </div>
          )
        })
      }
      </div>
    );
  }
}

export default Dest



// WEBPACK FOOTER //
// ./src/DestImg.js